import { LinkedIn } from './icons';
import footerLogo from '../assets/logo/main_logo_transparent_background.png';
import styles from './Footer.module.css';

const LINKEDIN = 'https://www.linkedin.com/company/jp-custom-works';

const SERVICES = [
  ['Strategic Consulting', '#services'],
  ['Custom Development', '#services'],
  ['Integration', '#services'],
  ['Training & Mentoring', '#services'],
  ['AI Enablement & Audits', '#ai'],
  ['Ongoing Support', '#services'],
];

const COMPANY = [
  ['Portfolio', '#portfolio'],
  ['Case Studies', '#cases'],
  ['About', '#about'],
  ['Contact', '#contact'],
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="wrap">
        <div className={styles.footGrid}>
          <div className={styles.footBrand}>
            <img src={footerLogo} alt="JP Custom Works logo — coral-red faceted gem with company name" />
            <div className={styles.tagline}>NetSuite · Development · AI</div>
            <p>
              An independent NetSuite consultant and developer who also ships full-stack software and AI
              solutions.
            </p>
          </div>
          <div className={styles.footCol}>
            <h4>Services</h4>
            {SERVICES.map(([label, href], i) => (
              <a key={`${label}-${i}`} href={href}>
                {label}
              </a>
            ))}
          </div>
          <div className={styles.footCol}>
            <h4>Company</h4>
            {COMPANY.map(([label, href]) => (
              <a key={label} href={href}>
                {label}
              </a>
            ))}
          </div>
          <div className={styles.footCol}>
            <h4>Connect</h4>
            <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
            <a href="mailto:sales@jpcustomworks.com">Email Me</a>
            <a href="#contact">Start a Conversation</a>
          </div>
        </div>
        <div className={styles.footBottom}>
          <p>© 2026 JP Custom Works.</p>
          <a className={styles.li} href={LINKEDIN} target="_blank" rel="noopener noreferrer">
            <LinkedIn />
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
